// extracted by mini-css-extract-plugin
export default {"container":"NotionProfilePage_container__KIHJE","header":"NotionProfilePage_header__cJ+Dr","title":"NotionProfilePage_title__2HQHZ"};